import React from 'react';
import { withTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

import { useMytaverseEvent } from '@core/dashboard/providers';

import { IAppLoader } from '../interfaces';

import { useStyles } from './styles';
import BasicButton from '@components/BasicButton';
import AppWrapper from '@components/AppWrapper';

import CircularProgress from '@components/CircularProgress';

const AppLoader = ({
  t: translate,
  showTeleportButton,
  handleTeleportButtonClick,
}: IAppLoader) => {
  const { currentEvent } = useMytaverseEvent();

  const classes = useStyles();

  return (
    <AppWrapper isAuthorized>
      <Box sx={classes.root}>
        <CircularProgress />
        <Typography sx={classes.title}>{currentEvent?.name}</Typography>
        <Typography sx={classes.text}>
          {translate('loading.transitionText')}
        </Typography>
        {showTeleportButton && handleTeleportButtonClick ? (
          <BasicButton primary onClick={handleTeleportButtonClick}>
            {translate('playScreen.play')}
          </BasicButton>
        ) : null}
      </Box>
    </AppWrapper>
  );
};

export default withTranslation()(AppLoader);
